
import { SunMoon, Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/ThemeProvider";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    if (theme === "dark") {
      setTheme("light");
    } else if (theme === "light") {
      setTheme("dark");
    } else {
      // Se o tema é "system", alternar entre light e dark com base na preferência do sistema
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "light"
        : "dark";
      setTheme(systemTheme);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            onClick={toggleTheme} 
            variant="ghost" 
            size="icon" 
            className="hover:bg-flame/5 rounded-xl"
          >
            {theme === "dark" ? (
              <Sun className="h-5 w-5 text-flame" />
            ) : theme === "light" ? (
              <Moon className="h-5 w-5 text-flame" />
            ) : (
              <SunMoon className="h-5 w-5 text-flame" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Alternar tema</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
